import { combineReducers } from 'redux';

import billingAddressesReducer from './billingAddresses/data/reducer';
import contactsReducer from './contacts/data/reducer';
import facilitiesReducer from './facilities/data/reducer';

const reducer = combineReducers({
  billingAddresses: billingAddressesReducer,
  contacts: contactsReducer,
  facilities: facilitiesReducer,
});

export { reducer };
